export const resultsViewModeTypes = {
    print: 'print',
    maincategories: 'maincategories',
    subcategories:  'subcategories',
    summary:        'summary',
    details:        'details'
};

export default resultsViewModeTypes;